export default function constant(x) {
  return () => x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/constant.js
// module id = 407
// module chunks = 0